import { ReactNode, useContext, useEffect } from "react";
import { useAnalyticsTracker } from "../../app/AnalyticsTracker";
import { PageStatusContext } from "../../app/PageStatusCtx";
import { useCurrentRoute } from "../../builder/mapping/page";
import { useUser } from "../../dataAccess/api/user";

interface Props {
  children: ReactNode;
  loading?: boolean;
}

function Page({ children, loading }: Props) {
  const pageContext = useContext(PageStatusContext);
  const { id: pageType } = useCurrentRoute() || {};
  const { AnalyticsTracker } = useAnalyticsTracker();
  const { user } = useUser();

  useEffect(() => {
    if (loading) {
      return;
    }
    AnalyticsTracker.trackIfPageLoad({ user, pageType, pageContext });
  }, [loading]);

  useEffect(() => {
    if (loading) {
      return;
    }
    AnalyticsTracker.trackIfPageChange({ pageType, pageContext });
  }, [pageType, loading]);

  return <>{children}</>;
}

export default Page;
